/* filepath: packages/volto-castle-theme/src/components/HPContactEmail/HPContactEmail.tsx */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

const isEmail = (s: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);

const HPContactEmail: React.FC = () => {
  const history = useHistory();
  const [email, setEmail] = React.useState('');

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const trimmed = email.trim();

    if (!isEmail(trimmed)) {
      toast.error('Please enter a valid email.');
      return;
    }

    history.push(`/contact?email=${encodeURIComponent(trimmed)}`);
  };

  return (
    <section className="hp-contact-email hp-fullbleed" aria-label="Contact email">
      <div className="hp-contact-email__container">
        <div className="hp-contact-email__card" role="region" aria-label="Contact email card">
          <div className="hp-contact-email__content">
            <h2 className="hp-contact-email__title">Contact Us</h2>
            <p className="hp-contact-email__subtitle">
              Enter your email address and get in touch with us!
            </p>

            <form className="hp-contact-email__form" onSubmit={onSubmit} noValidate>
              <label className="hp-contact-email__label" htmlFor="hp-contact-email-email">
                Email
              </label>
              <input
                id="hp-contact-email-email"
                className="hp-contact-email__input"
                type="email"
                inputMode="email"
                enterKeyHint="go"
                placeholder="Email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <button className="hp-contact-email__button" type="submit">
                <span className="hp-contact-email__buttonText">GET IN TOUCH</span>
                <span className="hp-contact-email__buttonArrow" aria-hidden="true">
                  →
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HPContactEmail;